import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserAffiliateDataApi } from 'api/user-affiliate-slice';
import toast from 'react-hot-toast';
import { getErrorString } from 'utils';

const initialState = {
  data: {},
  loading: false,
};

export const fetchUserAffiliateData = createAsyncThunk('user-affiliate/data', async (paramsObj = {}) => {
  try {
    const res = await getUserAffiliateDataApi(paramsObj, '');
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const UserAffiliateProgramSlice = createSlice({
  name: 'userAffiliateProgram',
  initialState,

  reducers: {
    setData: (state, { payload }) => {
      state.data = payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserAffiliateData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserAffiliateData.fulfilled, (state, { payload }) => {
        state.data = payload?.data || {};
        state.loading = false;
      })
      .addCase(fetchUserAffiliateData.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setData } = UserAffiliateProgramSlice.actions;
export default UserAffiliateProgramSlice.reducer;
